export type BrowserWindow = typeof globalThis.window;

export const getWindowObject = (): Partial<BrowserWindow> => globalThis.window || {};
